import React from "react";
import "./Interests.css";
import { Card } from "../../components";
import { ReactComponent as GraphicDesignSvg } from "../../assets/svgs/Graphic_Design.svg";
import { ReactComponent as UIDesignSvg } from "../../assets/svgs/web_design.svg";
import { ReactComponent as FullstackSvg } from "../../assets/svgs/Fullstack_development.svg";
import { ReactComponent as SEOSvg } from "../../assets/svgs/SEO.svg";
import { ReactComponent as VideEditingSvg } from "../../assets/svgs/Video_Editing.svg";
import { motion } from "framer-motion";

const cardsWrapperVariant = {
  hidden: {
    opacity: 0,
    transition: { when: "beforeChildren" },
  },
  show: {
    opacity: 1,
    transition: {
      duration: 1,
      staggerChildren: 0.5,
      delayChildren: 1,
    },
  },
};

const Interests = () => {
  return (
    <div id="interests">
      <h1>Interests</h1>
      <motion.div
        variants={cardsWrapperVariant}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        className="wrapper"
      >
        <Card image={<FullstackSvg />} description="Full Stack Development" />
        <Card image={<UIDesignSvg />} description="UI/UX Design" />
        <Card image={<SEOSvg />} description="Search Engine Optimization" />
        <Card image={<GraphicDesignSvg />} description="Graphic Design" />
        <Card image={<VideEditingSvg />} description="Video Editing" />
      </motion.div>
    </div>
  );
};

export default Interests;
